<div class="row">
  <div class="col-12 col-md-2 me-0" *ngIf="allowHtml">
    <button
      class="btn btn-primary"
      type="button"
      (click)="generateReport.emit()"
      [disabled]="disabled">
      View Report
    </button>
  </div>
  <div class="col-12 col-md-2" *ngIf="formats.length > 0">
    <button
      *ngIf="formats.length === 1"
      class="btn {{ downloadButtonStyle }} fw-bold"
      (click)="downloadReport.emit(formats[0].extension)"
      [disabled]="disabled"
      type="button">
      Download
    </button>
    <div *ngIf="formats.length > 1" #drop="ngbDropdown" ngbDropdown role="group">
      <span
        class="btn btn-link fw-bold"
        [class.disabled]="disabled"
        type="button"
        (mouseenter)="drop.open()"
        ngbDropdownAnchor
        >Download</span
      >
      <div ngbDropdownMenu>
        <button
          data-testid="formatOption"
          *ngFor="let format of formats"
          (click)="downloadReport.emit(format.extension)"
          ngbDropdownItem>
          Download as {{ format.name }} <i class="fas" [className]="format.icon"></i>
        </button>
      </div>
    </div>
  </div>
</div>
